/**
 * iCarsoft 搜索大弹窗(仿法国站)
 * 弹窗 DOM 完全由本脚本创建并挂到 body,不触碰主题搜索表单的任何结构。
 * 点击头部搜索框 → 打开模态(背景压暗,自带输入框):
 * - 空输入:最近浏览(localStorage['cc-recently-viewed'],主题产品页自动记录)+ 热门推荐
 * - 输入中:250ms 防抖,经 Section Rendering API 实时渲染匹配产品(前缀模糊)
 * - Enter 跳搜索页;✕ 清空/关闭;Esc 或点遮罩关闭
 * 若本脚本加载失败,头部原生搜索不受影响。
 */
(() => {
  const KEY = 'cc-recently-viewed';
  const cfg = document.querySelector('.js-icsp-cfg');
  if (!cfg || document.querySelector('.js-icsp')) return;
  const SRC = cfg.dataset.src;
  const SEARCH_URL = cfg.dataset.searchUrl || '/search';
  const PLACEHOLDER = cfg.dataset.placeholder || 'Search';

  // Critical positioning must not depend on the async-loaded CSS file. If a
  // customer taps search immediately after entering the page, the modal DOM is
  // appended near the end of <body>; without these fixed-position rules the
  // input focus can scroll the storefront to the footer.
  if (!document.getElementById('icsp-critical-style')) {
    const critical = document.createElement('style');
    critical.id = 'icsp-critical-style';
    critical.textContent = '.icsp-bg{position:fixed;inset:0;z-index:118;background:rgba(0,0,0,.38)}.icsp-bg[hidden],.icsp[hidden]{display:none!important}.icsp{position:fixed;left:50%;top:var(--icsp-top,90px);transform:translateX(-50%);z-index:120;width:min(1160px,96vw);max-height:calc(100vh - var(--icsp-top,90px) - 24px);display:flex;flex-direction:column;background:#fff;color:#111216;border-radius:16px;box-shadow:0 30px 70px rgba(0,0,0,.3);overflow:hidden;text-align:left}.icsp__body{overflow-y:auto}';
    document.head.appendChild(critical);
  }

  const readIds = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  };

  /* ===== 创建弹窗 DOM(挂 body,与主题表单完全隔离) ===== */
  const bg = document.createElement('div');
  bg.className = 'icsp-bg js-icsp-bg';
  bg.hidden = true;

  const panel = document.createElement('div');
  panel.className = 'icsp js-icsp';
  panel.hidden = true;
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-label', 'Search');
  panel.innerHTML =
    '<div class="icsp__bar">' +
      '<svg class="icsp__bar-ico" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4.2-4.2"/></svg>' +
      '<input class="icsp__input js-icsp-input" type="text" placeholder="' + PLACEHOLDER.replace(/"/g, '&quot;') + '" autocomplete="off" spellcheck="false" aria-label="Search">' +
      '<button type="button" class="icsp__x js-icsp-x" aria-label="Close">&#10005;</button>' +
    '</div>' +
    '<div class="icsp__body js-icsp-body"></div>';

  document.body.appendChild(bg);
  document.body.appendChild(panel);

  const input = panel.querySelector('.js-icsp-input');
  const body = panel.querySelector('.js-icsp-body');
  const xBtn = panel.querySelector('.js-icsp-x');

  let homeHTML = null;
  let debounceTimer = null;
  let ctrl = null;
  let anchor = null; // 当前触发的头部搜索框,用于定位

  const fetchPayload = async (q) => {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const res = await fetch(SRC + '&options%5Bprefix%5D=last&q=' + encodeURIComponent(q), { signal: ctrl.signal });
    if (!res.ok) throw new Error(res.status);
    const tpl = document.createElement('template');
    tpl.innerHTML = await res.text();
    return tpl.content.querySelector('[data-icsp-payload]');
  };

  const bindClear = () => {
    const clr = body.querySelector('[data-icsp-clear]');
    if (clr) clr.addEventListener('click', (e) => {
      e.preventDefault();
      try { localStorage.removeItem(KEY); } catch (err) {}
      const sec = body.querySelector('[data-icsp-recent]');
      if (sec) sec.remove();
      homeHTML = body.innerHTML;
    });
    // PC 端最近浏览超过 4 个 → 单行轮播 + 左右切换(样式在 CSS 中仅 ≥750px 生效)
    const rec = body.querySelector('[data-icsp-recent-grid]');
    const nav = body.querySelector('.icsp__nav');
    if (rec && nav) nav.querySelectorAll('button').forEach((b) => {
      b.addEventListener('click', () => {
        rec.scrollBy({ left: rec.clientWidth * Number(b.dataset.dir), behavior: 'smooth' });
      });
    });
  };

  const showHome = async () => {
    if (homeHTML !== null) {
      body.innerHTML = homeHTML;
      bindClear();
      return;
    }
    body.innerHTML = '<div class="icsp__loading">Loading…</div>';
    const ids = readIds();
    const q = ids.slice(0, 8).map((i) => 'id:' + i).join(' OR ') || 'id:0';
    try {
      const payload = await fetchPayload(q);
      if (!payload) { body.innerHTML = ''; return; }
      const grid = payload.querySelector('[data-icsp-recent-grid]');
      if (grid) {
        const order = ids.map(String);
        Array.from(grid.children)
          .sort((a, b) => order.indexOf(a.dataset.pid) - order.indexOf(b.dataset.pid))
          .forEach((c) => grid.appendChild(c));
      }
      // 超过 4 个最近浏览:标记轮播 + 插入左右切换按钮(仅 PC 显示)
      const recGrid = payload.querySelector('[data-icsp-recent-grid]');
      if (recGrid && recGrid.children.length > 4) {
        recGrid.classList.add('is-carousel');
        const head = payload.querySelector('[data-icsp-recent] .icsp__head');
        if (head && !head.querySelector('.icsp__nav')) {
          const nav = document.createElement('div');
          nav.className = 'icsp__nav';
          nav.innerHTML = '<button type="button" class="icsp__nav-btn" data-dir="-1" aria-label="Previous">&#8249;</button><button type="button" class="icsp__nav-btn" data-dir="1" aria-label="Next">&#8250;</button>';
          const clr = head.querySelector('[data-icsp-clear]');
          head.insertBefore(nav, clr);
        }
      }
      body.innerHTML = '';
      body.appendChild(payload);
      homeHTML = body.innerHTML;
      bindClear();
    } catch (e) { if (e.name !== 'AbortError') body.innerHTML = ''; }
  };

  const showResults = async (q) => {
    try {
      const payload = await fetchPayload(q);
      if (!payload) return;
      body.innerHTML = '';
      body.appendChild(payload);
    } catch (e) { /* AbortError 或网络错误:保留现有内容 */ }
  };

  const place = () => {
    let top = 90;
    if (anchor) {
      const r = anchor.getBoundingClientRect();
      if (r.width || r.height) top = Math.max(14, Math.round(r.top - 8));
    }
    panel.style.setProperty('--icsp-top', top + 'px');
  };

  const open = (fromInput) => {
    anchor = fromInput || anchor;
    place();
    bg.hidden = false;
    panel.hidden = false;
    document.body.style.overflow = 'hidden';
    if (!input.value.trim()) showHome();
    const y = window.scrollY;
    setTimeout(() => {
      try {
        input.focus({ preventScroll: true });
      } catch (e) {
        input.focus();
      }
      if (Math.abs(window.scrollY - y) > 4) window.scrollTo(0, y);
    }, 10);
  };
  const close = () => {
    panel.hidden = true;
    bg.hidden = true;
    document.body.style.overflow = '';
  };

  /* ===== 弹窗自身交互 ===== */
  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const q = input.value.trim();
    debounceTimer = setTimeout(() => { q ? showResults(q) : showHome(); }, 250);
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const q = input.value.trim();
      if (q) window.location.href = SEARCH_URL + '?q=' + encodeURIComponent(q) + '&type=product,page,article&options%5Bprefix%5D=last';
    }
  });
  xBtn.addEventListener('click', () => {
    if (input.value.trim()) {
      input.value = '';
      clearTimeout(debounceTimer);
      showHome();
      input.focus();
    } else {
      close();
    }
  });
  bg.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) close(); });
  window.addEventListener('resize', () => { if (!panel.hidden) place(); });

  /* ===== 头部搜索框仅作触发器(不改动其 DOM/表单;移动端内嵌搜索条仍在用) ===== */
  document.querySelectorAll('.js-search-input').forEach((t) => {
    t.addEventListener('focus', () => { open(t); t.blur(); });
    t.addEventListener('click', (e) => { e.preventDefault(); open(t); t.blur(); });
  });

  /* ===== 桌面端:在头部图标区插入搜索图标(输入条已由 CSS 隐藏) ===== */
  const iconsWrap = document.querySelector('store-header .header__icons');
  if (iconsWrap && !iconsWrap.querySelector('.icsp-trigger')) {
    const trig = document.createElement('button');
    trig.type = 'button';
    trig.className = 'header__icon icsp-trigger';
    trig.setAttribute('aria-label', 'Search');
    // svg 挂主题同款 .icon 类:顶部透明头/下滑白头的颜色切换规则都绑在 .header__icon>.icon 上
    trig.innerHTML = '<svg class="icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4.2-4.2"/></svg>';
    trig.addEventListener('click', (e) => { e.preventDefault(); open(trig); });
    iconsWrap.insertBefore(trig, iconsWrap.firstChild);
  }

  // Custom navigation can be re-rendered by the Shopify theme editor. Delegate
  // the event so desktop and mobile search triggers always open this panel.
  document.addEventListener('click', (e) => {
    const trig = e.target.closest('.js-icsp-open');
    if (!trig) return;
    e.preventDefault();
    open(trig);
  });
})();
